import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";
import CartItemsList from "./CartItemsList";
import Typography from "@mui/material/Typography";
import CartItemsPriceDetails from "./CartItemsPriceDetails";
import { getCartList } from "../../actions";
import CartSkeleton from "../Skeletons/CartSkeleton";
import { getCarItems } from "./cartUtil";
import { CartviewWrapper } from "./styles";
import { Button, Container } from "@mui/material";
import Footer from "../Footer";
import styled from "styled-components";
import CartitemListMobile from "./CartitemListMobile";
import CheckoutMobile from "./CheckoutMobile";
import CheckoutPriceDetailsNew from "../Checkout/CheckoutPriceDetails/CheckoutPriceNew";
import ShipmentsList from "../Checkout/CheckoutSummary/ShimpentsList";
import ShipmentsListNew from "./ShipmentListNew";
import PlaceOrderCTANew from "./PlaceOrderCTA/indexNew";
import CartShimmerSkeleton from "./cartShimmerSkeleton";
import DeliveryDetailsSection from "./DeliveryDetailsSection";
import { applyCoupon } from "./applyCoupon";
import { chooseToken } from "../../utils";

const ViewCartNew = () => {
  const dispatch = useDispatch();

  const getExistingPincode = localStorage.getItem("pincode") || 474001;
  const parsePincode = JSON.parse(getExistingPincode) || "";
  const [emptyCart, setEmptyCart] = useState(false);
  const [checkGuest, setCheckGuest] = useState(false);
  const [shipmentsCount, setShipmentsCount] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState({ error: false, errorDetails: "" });
  const cartList = useSelector(
    (state) => state?.AllCartItems?.AllCartData || {}
  );
   const { userId = "" } = chooseToken();

  console.log("cartList", cartList);


  const { cartPriceDetail = {}, shipments = [] } = cartList || {};

  const updatePincode = useSelector(
    (state) => state.productDetails?.updatedPincode || ""
  );

  const guestUser = useSelector((state) => state.userDetails?.isGuest);
 

  const getCartData = async () => {
    
    setIsLoading(true);
    setIsError({ error: false, errorDetails: "" });
    const AllcartData = await getCarItems({
      setIsError,
      setIsLoading,
      pincode: parsePincode,
    });
    if (AllcartData?.data?.shipments.length) {
      setEmptyCart(false);
      dispatch(getCartList(AllcartData?.data));
    }
    setEmptyCart(true);
    setIsLoading(false);
  };

    const handleApplyCoupon = async (coupon) => {


      console.log("coupon", coupon);
    
    setIsLoading(true);
    setIsError({ error: false, errorDetails: "" });
    const AllcartData = await applyCoupon({
      setIsError,
      setIsLoading,
      pincode: parsePincode,
      couponCode:coupon?coupon:"",
      cartID: userId,
    });
    if (AllcartData?.data?.shipments.length) {
      setEmptyCart(false);
      dispatch(getCartList(AllcartData?.data));
    }
    setEmptyCart(true);
    setIsLoading(false);
  };
  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    if (true) {
      getCartData();
    } else {
      setEmptyCart(true);
    }
    if (shipments?.length > 0) {
      let cartItemsCount = shipments?.reduce((prev, curr) => {
        let count = curr?.cartItemDetails?.length;
        prev = prev + count;
        return prev;
      }, 0);
      setShipmentsCount(cartItemsCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCheckGuest(guestUser);
  }, [guestUser]);
  useEffect(() => {
    if (updatePincode?.length) {
      getCartData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatePincode]);
  /* 
  useMemo(() => {
    const getCartData = async () => {
      setIsLoading(true);
      const AllcartData = await getCarItems({ setIsError, setIsLoading });
      if (AllcartData?.data) {
        dispatch(getCartList(AllcartData?.data));
      }
      setIsLoading(false);
    };
    if (updateCartItems !== previousObject.current) {
      getCartData();
      previousObject.current = updateCartItems;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCartItems]); */


 const EmptyCart = styled.div`
 
 display:flex;
 justify-content:center;
 align-items:center;
 min-height:81vh;
 width:100%;
 flex-direction:column;



 `
 const isMobile = window.innerWidth <= 600;

 console.log("shipments", shipments);

 const MobileCartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: .5rem;
  width: 100%;
  position:relative;
  height:94vh;

  `

  const ViewCartWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 95vh;
    background-color: #f5f5f5;
    margin-top: 4rem;
    padding: 2rem 1rem 1rem 1rem;
    font-family: "Ancizar Sans", sans-serif;

    @media (max-width: 900px) {
      flex-direction: column;
       padding: 5rem 1rem 1rem 1rem;
    }

    @media(max-width:500px){
    font-famiy: "Ancizar Sans", sans-serif;
     padding: 2rem .5rem .5rem .5rem;
    
    }

  `

   const CheckoutRightContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;


  `;


  const CheckoutLeftContainer = styled.div`
     display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    width: 101%;

    @media (max-width: 900px) {
      flex: unset;
      width: 100%;
    }
  `

  const EmptyCartContainer = styled.div`
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-family: "Ancizar Sans", sans-serif;
  font-size: 1rem;
  
  width: 100%;
  margin-top: 5rem;
  
  `
  const ExploreProductsButton = styled.button`
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  background-color: #6b9b1c;
  width: 200px;
  height: 40px;
  font-size: 16px;
  border-radius: 8px;
  font-family: "Ancizar Sans", sans-serif;
  color: white;
  cursor: pointer;

  
  
  `

  return (
    <ViewCartWrapper>



     {shipments?.length > 0 && <>   <CheckoutLeftContainer>

        {isLoading?<>

        <CartShimmerSkeleton/> 
        
        </>:<> 
          <DeliveryDetailsSection />
        
         {shipments?.map((shipment, index) => {
            return <ShipmentsListNew key={index} ship={shipment} />;
          })}</>}

          <PlaceOrderCTANew/>

      </CheckoutLeftContainer>

      <CheckoutRightContainer>

        <CheckoutPriceDetailsNew
          cartPriceDetail={cartPriceDetail}
          shipmentLength={shipmentsCount}
          handleApplyCoupon={handleApplyCoupon}
        />

      </CheckoutRightContainer></>}



      {!shipments?.length && !isError?.error && emptyCart &&<>
      <EmptyCartContainer>
        <p>Your Cart is Empty</p>
        <ExploreProductsButton onClick={() => window.location.href = '/'}>Explore Products</ExploreProductsButton>

      </EmptyCartContainer>
      
      </>}

    </ViewCartWrapper>
  )
};

export default ViewCartNew;
